import { SET_CONTACT_DETAILS } from '../../constants/actions';
import { AppState } from '../../types';

export const initialAppState: AppState = {
  contactInfo: {},
};

export interface Action<TType = string, TPayload = any> {
  type: TType;
  payload: TPayload;
}

export function appStateReducer(state: AppState = initialAppState, action: Action): AppState {
  switch (action.type) {
    case SET_CONTACT_DETAILS:
      return { ...state, contactInfo: action.payload };
    default:
      return state;
  }
}
